import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";
import { ToastService } from "@shared/lib/services";
import { IReportDetail } from "@shared/lib/types/reports";
import { REPORTS_LIST_QUERY_KEY } from "../constants";
import { ReportService } from "../services/Report.servie";

export function useEditCost(reportId: string, reportDetailQueryKey: unknown[]) {
  const {
    mutate: editCost,
    isLoading: isEditing,
    isSuccess: isEdited,
    variables,
  } = useMutation({
    mutationFn: async ({
      reportMediaId,
      cost,
    }: {
      reportMediaId: string;
      cost: number;
    }) => {
      return await ReportService.updateReportMediaCost(
        reportMediaId,
        cost
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, response, { reportMediaId }) => {
      const updatedMedia = response.data;
      c.setQueryData(
        reportDetailQueryKey,
        (oldData: BackednResponse<IReportDetail> | undefined) => {
          if (!oldData?.data) return oldData;
          return {
            ...oldData,
            data: {
              ...oldData.data,
              data: oldData.data.data?.map((item) =>
                item._id === reportMediaId && updatedMedia ? updatedMedia : item
              ),
            },
          };
        }
      );

      c.invalidateQueries({
        queryKey: [REPORTS_LIST_QUERY_KEY, reportId, reportMediaId],
      });
    },
  });

  return {
    editCost,
    isEditing,
    isEdited,
    variables,
  };
}
